<template>
    <div>
        <TransactionsList/>
    </div>
</template>

<script>
import TransactionsList from '../../components/transactions/TransactionsList';

export default {
  components: {
    TransactionsList,
  },
};
</script>
